export const env = process.env.NODE_ENV;

export default (ap1, ap2) => {

    // return `http://127.0.0.1:8000/${ap1}/${ap2}`;
    // COMPART
    // return `https://stshop.club:81/${ap1}/${ap2}`;
    // DEMO
    // return `https://stshop.club:89/${ap1}/${ap2}`;
    // VANCOUVER
    // return `https://stshop.club:86/${ap1}/${ap2}`;
    // REY BOTANERO
    // return `https://stshop.club:443/${ap1}/${ap2}`;
    // return `https://74.208.235.128:85/${ap1}/${ap2}`;

    //UBUNTU SERVER
    // DEMO
    // return `https://ubuntu1.stshop.club/${ap1}/${ap2}`;
    // Vancouver
    // return `https://ubuntu1.stshop.club:82/${ap1}/${ap2}`;
    // COMPART
    // return `https://ubuntu1.stshop.club:81/${ap1}/${ap2}`;
    // BOTANERO
    // return `https://ubuntu1.stshop.club:83/${ap1}/${ap2}`;
    // Diesel
    // return `https://ubuntu1.stshop.club:85/${ap1}/${ap2}`;
    // ARCOS
    // return `https://ubuntu1.stshop.club:89/${ap1}/${ap2}`;

    // ELECTRIMEX
    return `https://ubuntu1.stshop.club:91/${ap1}/${ap2}`;

    // ALITAS
    // return `https://ubuntu1.stshop.club:71/${ap1}/${ap2}`;
    // PINJAQUE
    // return `https://ubuntu1.stshop.club:75/${ap1}/${ap2}`;
};


// WEBPACK FOOTER //
// ./src/common/functions/api-resource.js